module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAuCAMAAABpjHt/AAAAS1BMVEVheu3///9heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu1heu3Mp4dnAAAAGHRSTlMAABAgMEBQYHB/gJCfoK+wv8DP0N/g7/ANaAJnAAAA30lEQVQ4y+3VwW7DIBRE0SkY7OKmgEPr+/9f2oUTu6miPLrKJrM+QsNDgN66oxeV4oKZJUrSB11JUqQzQRVOTkZchizAlJIHBKgjz6BjoX2GDurKNqPJphnWWoFo0QHOTgrQ/tD9TK40XZabYbDptjcIBp2OVb3R1UPzUoQvcwIzUFrPBDRcGjVn0QiwAizuMfXfMHspnKHc0vR+ZJR02k+0bm3vDAuoklbqMYr8iA6Qrl0q7bbAr4yST8nvG0zpSbfgHu293BmK/WQUyAr9D5FSn5wkKVQb5iC9fph/0B/kuTXPyjygbwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ico-idcard.png
// module id = FkV6
// module chunks = 1